package com.neurobs.react

import org.scalajs.dom.{Event, HTMLElement}
import org.scalajs.dom.html.Element
import slinky.core.{FunctionalComponent, SyntheticEvent}
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useEffect
import slinky.core.facade.{React, ReactElement}
import slinky.web.html._

import scala.scalajs.js

/** Displays the contained elements inside a modal window */
@react object ModalContainer {
	case class Props(children: ReactElement*)

	val component = FunctionalComponent[Props] { props =>
		// Prevents Escape from closing modal dialogs, which is default behavior
		def cancelHandler(e: SyntheticEvent[Element, Event]): Unit = {
			e.preventDefault()
		}

		val dialogRef = React.createRef[HTMLElement]
		useEffect({ () =>
			if (dialogRef.current != null) {
				dialogRef.current.asInstanceOf[js.Dynamic].showModal()
			}
		}, Seq())

		dialog(
			className := modalClass,
			ref := dialogRef,
			onCancel := (cancelHandler(_))
		)(
			props.children:_*
		)
	}

	private val modalClass = "modal-window"
}
